'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styling = require('@rexlabs/styling');

var _tabBar = require('./tab-bar');

var _tabBar2 = _interopRequireDefault(_tabBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyles = (0, _styling.StyleSheet)({
  container: {
    width: '100%'
  },

  tabHidden: {
    display: 'none'
  }
});

var Tabs = (_dec = (0, _styling.styled)(defaultStyles), _dec(_class = (_temp2 = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(Tabs, _PureComponent);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.prevIndex = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tabs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.activeTab !== nextProps.activeTab) {
        this.prevIndex = this.props.items.findIndex(function (i) {
          return i.name === _this2.props.activeTab;
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          items = _props.items,
          activeTab = _props.activeTab,
          onChange = _props.onChange,
          TabBar = _props.TabBar,
          s = _props.styles,
          alwaysRenderAll = _props.alwaysRenderAll,
          rest = (0, _objectWithoutProperties3.default)(_props, ['children', 'items', 'activeTab', 'onChange', 'TabBar', 'styles', 'alwaysRenderAll']);

      // Some invariant validations of props with meaningful error messages

      (0, _invariant2.default)(activeTab !== undefined, 'You have to define an \'activeTab\' prop on Tabs.\n\n' + 'If you don\'t want to deal with the tab state handling, ' + 'you can use \'TabStateful\' instead!');

      (0, _invariant2.default)(onChange !== undefined, 'You have to define an \'onChange\' hanlder on Tabs.\n\n' + 'If you don\'t want to deal with the tab state handling, ' + 'you can use \'TabStateful\' instead!');

      items.forEach(function (item) {
        (0, _invariant2.default)(item.name, 'You have to define a unique name for each tab item!');
      });

      var tabs = items.map(function (_ref2, index) {
        var name = _ref2.name,
            _ref2$Tab = _ref2.Tab,
            Tab = _ref2$Tab === undefined ? function () {
          return null;
        } : _ref2$Tab;

        var isActive = name === activeTab || !activeTab && index === 0;
        var shouldBeRendered = alwaysRenderAll || isActive;
        return shouldBeRendered ? _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, s('tab', { tabHidden: !isActive }), {
            key: name,
            role: 'tabpanel',
            'aria-hidden': false
          }),
          _react2.default.createElement(Tab, { index: index })
        ) : null;
      });

      var info = {
        tabs: tabs,
        prevIndex: this.prevIndex
      };

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, s.with('container')(this.props), rest),
        _react2.default.createElement(TabBar, { activeTab: activeTab, onChange: onChange, items: items }),
        _react2.default.createElement(
          'div',
          s('tabs'),
          children ? children(info) : tabs
        )
      );
    }
  }]);
  return Tabs;
}(_react.PureComponent), _class2.displayName = 'Tabs', _class2.defaultProps = {
  TabBar: _tabBar2.default
}, _temp2)) || _class);
process.env.NODE_ENV !== "production" ? Tabs.propTypes = {
  children: _propTypes2.default.func,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
    name: _propTypes2.default.string.isRequired,
    Tab: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func])
  })).isRequired,
  activeTab: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  TabBar: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  alwaysRenderAll: _propTypes2.default.bool
} : void 0;
exports.default = Tabs;